import { action } from 'mobx';
import { IContentItem } from '../../exported/product-grid-wrapper/ProductGridWrapper';
import { IItemsParams } from '../../api/ProdcatApiSdk';
import { ProductGridService } from '../domain/services/ProductGridService';

export class ProductGridLoadedUseCase {
    private productGridService: ProductGridService;
    private content: IContentItem[];
    private productTags: string[];
    private itemParams: IItemsParams;

    constructor(
        content: IContentItem[],
        itemParams: IItemsParams,
        productTags: string[],
        productGridService: ProductGridService
    ) {
        this.productGridService = productGridService;
        this.content = content;
        this.itemParams = itemParams;
        this.productTags = productTags;
    }

    @action
    public execute = async () => {
        const { itemParams, productTags, content } = this;

        this.productGridService.setInlineContent(content);
        await this.productGridService.getProductsByParams(itemParams, productTags);
    };
}
